export default __webpack_public_path__ + "static/media/Emojis07.18f264fd.png";